export class DataModel {
    constructor (public action: string,
                 public value: string) {
    }
}
